import type { QueryObserverOptions } from '@tanstack/react-query'

import {
    type GetUserRequestsByExternalIdWatchdocsUserRequestId400,
    type GetUserRequestsByExternalIdWatchdocsUserRequestIdQueryKey,
    type GetUserRequestsByExternalIdWatchdocsUserRequestIdQueryResponse,
    useGetUserRequestsByExternalIdWatchdocsUserRequestId,
} from '@/shared/api'
import type { ResponseErrorConfig } from '@/shared/api/axios-client'

interface UseRequestFetchProps {
    id: string
    query?: Partial<
        QueryObserverOptions<
            GetUserRequestsByExternalIdWatchdocsUserRequestIdQueryResponse,
            ResponseErrorConfig<GetUserRequestsByExternalIdWatchdocsUserRequestId400>,
            GetUserRequestsByExternalIdWatchdocsUserRequestIdQueryResponse,
            GetUserRequestsByExternalIdWatchdocsUserRequestIdQueryResponse,
            GetUserRequestsByExternalIdWatchdocsUserRequestIdQueryKey
        >
    >
}

export const useRequestFetch = ({ id, query }: UseRequestFetchProps) => {
    const { data, isLoading, error } = useGetUserRequestsByExternalIdWatchdocsUserRequestId(id, {
        query,
    })

    return {
        data,
        isLoading,
        error,
    }
}
